import { type Context, type Input } from './sweetpass-checkout.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(input: Input): Context {
  return {
    sweetpassId: input.sweetpassId,
    amount: input.amount,
    stripeSession: '',
    stripeIntentConfig: null,
    stripeElementConfig: null,
    stripeConfirmHandlerRef: input.stripeConfirmHandlerRef,
    stripeFailedToLoad: false,
    confirmStripe: confirmStripeNotRegistered,
    purchaseAttempt: 0,
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

/**
 * Placeholder until the mounted payment element registers its `confirmStripe`.
 */
async function confirmStripeNotRegistered() {
  return {
    status: 'failed',
    error: new Error('Stripe payment element is not ready'),
  } as const;
}
